import React from 'react';
import Udesk from 'Udesk';
import { isDefaultFilter, isSavedDefaultFilter } from '../custom-filter-modal/utils';
import { getSearchTemplateRelatesListDefault } from 'src/api/searchTemplateRelates/listDefault';

class FilterManageComponent extends React.Component {
    //#region Default Props
    static propTypes = {};
    static defaultProps = {
        type: Udesk.enums.filterTypes.call.id,
        filterManageTitle: '',
        onEditFilter: null,
        allFilterTitle: '',
        onSelectedFilterChanged: null,
        isUpdate: false,
    };
    //#endregion

    state = {};
    privates = {
        storages: {
            paging: {},
            selectedFilter: {},
            // 首次进入
            isFirstEntry: true,
        },
        filters: [],
        isActionsVisible: false,
        totalCount: '',
        defaultSearchTemplate: {},
        savedDefaultFilter: undefined,
    };
    enableStorage = true;
    // 区分不同数据源的页面缓存，不共用，以免产生 bug
    _storageKey =
        'FilterManage' +
        ((Udesk.enums.inspectDataSources.find((e) => e.id === Number(this.props.type)) &&
            Udesk.enums.inspectDataSources.find((e) => e.id === Number(this.props.type)).key) ||
            '');
    storageStrategies = {
        storageWay: 'sessionStorage',
        extraStorages: [],
        resetStrategies: {
            transitionToRoutes: [],
            notTransitionToRoutes: [
                /^\/site\/dialogue-manage\/view/i,
                /^\/site\/call-manage\/view/i,
                /^\/site\/wechat-qa\/chart-record\/detail/i,
                /^\/site\/ticket-manage\/view/i,
                /^\/site\/e-commerce-manage\/view/i,
                /^\/site\/e-comment-manage\/view/i,
                /^\/conversation-analysis\/e-comment-manage\/view/i,
                /^\/site\/m-comment-manage\/view/i,
                /^\/conversation-analysis\/m-comment-manage\/view/i,
                /^\/site\/survey-manage\/view/i,
                /^\/site\/video-call-manage\/view/i,
                /^\/site\/feishu-qa\/group-dialogue-manage\/view/i,
            ],
        },
    };

    // 注意：关闭后取消自动加载 asyncModel，需要手动调用 reloadAsyncModel
    autoLoad = false;

    static computes = {};
    actions = {
        changeSelectFilter(filter, isDefault) {
            if (filter) {
                this.privates.storages.selectedFilter = filter;
            } else {
                this.privates.storages.selectedFilter = {
                    // id: null
                };
            }
            this.actions.getFilterDetail(this.privates.storages.selectedFilter, isDefault);
            this.actions.update();
        },
        pageChanged(pageNum, pageSize) {
            this.actions.reloadAsyncModel({ pageNum });
        },
        changeActionsVisible() {
            let { isActionsVisible } = this.privates;
            this.privates.isActionsVisible = !isActionsVisible;
            this.actions.update();
        },
        editFilter(filter) {
            this.actions.getFilterDetail(filter);
            this.trigger('onEditFilter', filter);
        },
        deleteFilter(filter) {
            let {
                locales,
                props: { sdkOptions },
            } = this;
            let onConfirm = () => {
                let url = Udesk.business.apiPath.concatApiPath(
                    `search-template/${filter.id}`,
                    sdkOptions
                );
                Udesk.ajax.del(url).then(
                    (resp) => {
                        Udesk.ui.notify.success(locales.business.notifyMessage.deleteSuccess);
                        this.actions.reloadAsyncModel();
                    },
                    (reason) => {
                        Udesk.ui.notify.error(
                            reason.errorMsg || locales.business.notifyMessage.deleteFailed
                        );
                    }
                );
            };

            Udesk.ui.alerts.confirm({
                content: locales.labels.deleteContent,
                onOk: onConfirm,
            });
        },
        getFilterDetail(filter, isDefault) {
            if (filter && filter.id) {
                let { sdkOptions } = this.props;
                let url = Udesk.business.apiPath.concatApiPath(
                    `search-template/${filter.id}`,
                    sdkOptions
                );
                if (isDefault) {
                    this.trigger('onSelectedFilterChanged', this.privates.defaultSearchTemplate);
                    return;
                }
                Udesk.ajax.get(url).then(
                    (resp) => {
                        this.trigger('onSelectedFilterChanged', resp.data);
                    },
                    (reason) => {
                        Udesk.ui.notify.error(
                            reason.errorMsg ||
                                this.locales.components.pages.components.filterManage
                                    .getFilterDetailFailed
                        );
                    }
                );
            } else {
                this.trigger('onSelectedFilterChanged');
            }
        },

        getDefaultFilter(callback) {
            getSearchTemplateRelatesListDefault().then((res) => {
                const defaultFilterList = res.data || [];

                this.privates.savedDefaultFilter = defaultFilterList.find((f) =>
                    isSavedDefaultFilter({
                        filter: f,
                        filterType: Udesk.enums.customFilterListType.datasourceManagement.id,
                        templateType: this.props.type,
                    })
                );

                this.actions.update();

                callback && callback();
            });
        },
    };

    //#region Life Cycle
    init() {
        let type = this.props.type;
        //回显默认筛选器
        if (type === Udesk.enums.filterTypes.wechatAll.id) {
            type = Udesk.enums.filterTypes.wechat.id;
        }
        let defaultSearchTemplate = this.props.sdkOptions.props.defaultSearchTemplate.find(
            (template) => `${template.templateType}` === type
        );
        let transitionParams = JSON.parse(localStorage.getItem('maualAddToManage_pamars'));

        if (defaultSearchTemplate) {
            if (transitionParams === null) {
                this.privates.storages.selectedFilter = defaultSearchTemplate;
            }
            this.privates.defaultSearchTemplate = defaultSearchTemplate;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let { isUpdate } = this.props;
        if (isUpdate !== prevProps.isUpdate) {
            this.actions.reloadAsyncModel();
        }
    }
    componentDidMount() {
        this.actions.getDefaultFilter(() => {
            this.actions.reloadAsyncModel();
        });
    }
    asyncModel(changedParams) {
        let { sdkOptions, type } = this.props;
        let params = Object.assign(
            {},
            {
                type: type,
                pageNum:
                    this.privates.storages.paging.pageNum || Udesk.config.paging.defaultPageNumber,
                pageSize: Udesk.config.paging.defaultPageSize,
            },
            changedParams
        );
        let url = Udesk.business.apiPath.concatApiPath(`search-template`, sdkOptions);
        let filtersPromise = new Promise((resolve, reject) => {
            Udesk.ajax.post(url, params).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg ||
                            this.locales.components.pages.components.filterManage
                                .getFiltersListFailed
                    );
                    reject(reason);
                }
            );
        });

        let totalCountUrl = Udesk.business.apiPath.concatApiPath(`data/${type}/count`, sdkOptions);
        let totalCountPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(totalCountUrl).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg ||
                            this.locales.components.pages.components.filterManage.getAllCountFailed
                    );
                    reject(reason);
                }
            );
        });

        return {
            filters: filtersPromise,
            totalCount: totalCountPromise,
        };
    }
    parseAsyncModel(asyncModel, { asyncKey }) {
        return asyncModel;
    }
    onAsyncModelResolved(asyncModel, parseOptions) {
        let { asyncResult, asyncKey } = parseOptions;
        if (asyncKey === 'filters') {
            if (asyncResult) {
                if (asyncResult.data && asyncResult.data.length > 0) {
                    this.privates.filters = asyncResult.data;
                } else {
                    this.privates.filters = [];
                }

                // 处理默认筛选
                // 只有在首次进入时才使用默认筛选
                // 其他情况使用最后一次选择的筛选， 直接触发请求
                // 原因：有缓存数据
                if (this.privates.storages.isFirstEntry) {
                    this.privates.storages.isFirstEntry = false;
                    const defaultFilter = this.privates.filters.find((f) =>
                        isDefaultFilter({
                            filter: f,
                            savedDefaultFilter: this.privates.savedDefaultFilter,
                        })
                    );

                    if (defaultFilter) {
                        this.actions.changeSelectFilter(defaultFilter, false);
                    } else {
                        this.trigger('onFiltersEnd');
                    }
                } else {
                    this.trigger('onFiltersEnd');
                }

                if (asyncResult.paging) {
                    this.privates.storages.paging = asyncResult.paging;
                }
                this.actions.update();
            }
        } else if (asyncKey === 'totalCount') {
            if (asyncResult) {
                if (asyncResult.data) {
                    this.privates.totalCount = asyncResult.data;
                }
                this.actions.update();
            }
        }
    }
    //#endregion
}

export default FilterManageComponent;
